<app-bottom-sheet-title (dismiss)="dismiss(CloseStateEnum.Close)">
    {{ tool?.name }}
</app-bottom-sheet-title>

@if (tool) {
<div class="wrapper">
    <div class="items">
        <div class="items__title" i18n>Mijn opgeslagen {{ tool.name }}</div>
        <div class="items__items">
            <app-scroll #scrollItems>
                <div
                    class="item item--new"
                    (click)="dismiss(CloseStateEnum.New)"
                >
                    <div class="item__preview">
                        <i class="fas fa-plus-square"></i>
                    </div>
                    <div class="item__title">
                        <span class="text" i18n>Nieuw</span>
                    </div>
                </div>
                @for (item of tool.toolScreenshots; track item) {
                <div
                    class="item item--existing"
                    (click)="onScreenshotClick(item)"
                >
                    <div
                        class="item__preview"
                        [style]="{
                            'background-image': 'url(' + item.preview + ')'
                        }"
                    ></div>
                    <div class="item__title">
                        <span
                            class="text"
                            (click)="onRenameClick($event, item)"
                            >{{ item.title }}</span
                        >
                        <span
                            class="delete"
                            (click)="onDeleteScreenshotClick($event, item)"
                        >
                            <i class="fas fa-trash"></i>
                        </span>
                    </div>
                </div>
                }
            </app-scroll>
        </div>
        <app-scroll-indicator
            [ngClass]="tool.children ? 'small' : undefined"
            [scroll]="scrollItems"
        ></app-scroll-indicator>
    </div>
    @if (tool?.children?.length > 0) {
    <div class="items items--provided">
        <div class="items__title" i18n>Aangeboden {{ tool.name }}</div>
        <div class="items__items">
            <app-scroll #scrollItems class="items-grid">
                @for (child of tool.children; track child) {
                <div class="item" (click)="onChildClick(child)">
                    <div class="item__title">
                        <span class="text">{{ child.name }}</span>
                    </div>
                </div>
                }
            </app-scroll>
        </div>
        <app-scroll-indicator
            class="small"
            [scroll]="scrollItems"
        ></app-scroll-indicator>
    </div>
    }
</div>
}

<app-button class="back" (click)="dismiss(CloseStateEnum.Close)">
    <i class="fas fa-arrow-left"></i>
    <span i18n>Terug</span>
</app-button>
